import UpdateRole from "./UpdateRole";
export default UpdateRole;
